import { apiFetch } from '@/platform/lib/api';
import { SAAS_HOST_UI } from '@/platform/saas/saasHostUi';
import {
  resolveHostPostLoginPath,
  type SaasCommunityRow,
} from '@/platform/saas/saasCommunities';

/** Apex marketing Sign in: picker if the user has memberships, otherwise Find. */
export async function hostAwareReturnTo(returnTo: string): Promise<string> {
  const fallback = returnTo.startsWith('/') ? returnTo : '/';
  if (!SAAS_HOST_UI) return fallback;
  return resolveHostPostLoginPath(fallback, async () => {
    const res = await apiFetch<{ communities?: SaasCommunityRow[] }>('/saas/me/communities');
    return res.communities;
  });
}
